import * as React from 'react';
import { Hooks } from '@grandvisionhq/carts-v2';
import { useLocation } from '@grandvisionhq/frk-routing';
import { updateActiveVariant } from '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import { PowerDropdown } from './PowerDropdown.js';

const PowerDropdownContainer = ({ onChange , label , selectedSize , options , className ,  })=>{
    const { dispatch , product , activeVariant  } = useProductData();
    const formatter = Hooks.useGetProductLinkFormatter();
    const { query  } = useLocation();
    const handleChange = (item)=>{
        const queryParams = [
            ...query
        ].length > 0 ? query : undefined;
        const productLink = formatter(activeVariant.slug, item.value, product.productType, queryParams);
        dispatch(updateActiveVariant({
            sku: item.value
        }));
        window.history.replaceState(null, '', productLink);
        onChange(item);
    };
    return /*#__PURE__*/ React.createElement(PowerDropdown, {
        label: label,
        selectedSize: selectedSize,
        options: options,
        className: className,
        onChange: handleChange
    });
};

export { PowerDropdownContainer };
//# sourceMappingURL=PowerDropdownContainer.js.map
